import { create, } from "zustand";
import type { MessageProps,  SendMessageProps, } from "./types";

export declare type MessengerStore = {
	messages: MessageProps[];
	sendMessage: ( props: SendMessageProps, ) => void;
}


export const useMessengerStore = create<MessengerStore>()((set, get) => ({

	messages: [],

	sendMessage: ({
		title,
		message,
		severity,
		duration = 5000,
	}: SendMessageProps ) => {
		const { messages, } = get();
		const id = Math.random()
		const next = messages.concat({ id, title, message, duration, severity, created: new Date(), });

		set({ messages: next });

		setTimeout(() => {
			const { messages, } = get();
			set({ messages: messages.filter(message => message.id !== id), });
		}, duration);

	}

}));
